<template>
  <ChaoweiPrescriptionPage :config="config" />
</template>

<script>
import ChaoweiPrescriptionPage from "@/components/smallComponents/ChaoweiPrescriptionPage.vue";

export default {
  components: { ChaoweiPrescriptionPage },
  data() {
    return {
      config: {
        pageTitle: "调理方案信息",
        fetchApi: "/api/health/v2/beveragePrescription/grouped",
        contactRoute: "/chaoweiContact",
        homeRoute: "/",
        fulfillmentRoute: "/fulfillmentOrder",
        fulfillmentConfirmRoute: "/fulfillmentConfirm",
        prescriptionImageRoute: "/chaoweiPrescriptionImage",
      },
    };
  },
};
</script>
